import { createNamespacedHelpers } from 'vuex';

const { mapState: mapConciergeState } = createNamespacedHelpers('Concierge');

export default {
  name: 'ReferenceContent',
  props: {
    language: {
      type: String,
      default: 'en-US'
    },
    currentReference: Object
  },

  // TODO: Store in JSON file, and import
  // eslint-disable-next-line max-lines-per-function
  data: function() {
    return {
      content: {
        'en-US': {
          restaurantLinks: [
            {
              link: 'https://tabelog.com/en/',
              name: 'Tabelog',
              backDescription:
                '(Normally over 3.4 rating restaurants would be great.)'
            }
          ],
          activityLinks: [
            {
              link: 'https://www.klook.com/en-US/?aid=7278',
              name: 'Klook'
            }
          ],
          accomodationLinks: [
            {
              link: 'https://www.booking.com/index.html?aid=1285618',
              name: 'Booking.com'
            },
            {
              link: 'https://www.airbnb.com/c/guoxuanp',
              name: 'Airbnb'
            }
          ],
          popularActivityLinks: [
            {
              link:
                'https://www.klook.com/en-US/activity/1420-7-day-whole-japan-rail-pass-jr-pass/?aid=7278',
              name: '[Ordinary Car] 7 Day Whole Japan Rail Pass',
              frontDescription: 'Transportation'
            },
            {
              link:
                'https://www.klook.com/en-US/activity/3037-14-day-whole-japan-rail-pass-jr-pass/?aid=7278',
              name: '[Ordinary Car] 14 Day Whole Japan Rail Pass',
              frontDescription: 'Transportation'
            },
            {
              link:
                'https://www.klook.com/en-US/activity/16399-4g-wifi-japan/?aid=7278',
              name: '4G Portable WiFi for Japan from Uroaming (Unlimited Data)',
              frontDescription: 'Internet'
            },
            {
              link:
                'https://www.klook.com/en-US/activity/16706-docomo-4g-sim-japan/?aid=7278',
              name: '4G SIM Card (Japan Pick Up) for Japan',
              frontDescription: 'Internet'
            },
            {
              link:
                'https://www.klook.com/en-US/activity/835-universal-studios-japan-ticket-osaka/?aid=7278',
              name: 'Universal Studios Japan™ 1 Day E-Ticket',
              frontDescription: 'Ticket'
            }
          ],
          reservationMessage: `If you want to make a reservation, please join the Tabiko Premium Membership Program ~✨<br>
          You can make reservations for free and get access to a whole bunch of other benefits! For more details, head over to the “Info” tab and look for “Upgrade to Tabiko premium” to learn more.`
        },
        'zh-TW': {
          restaurantLinks: [
            {
              link: 'https://tabelog.com/tw/',
              name: 'Tabelog',
              backDescription: '（基本上評分超過3.4星較為推薦）'
            }
          ],
          activityLinks: [
            {
              link: 'https://www.klook.com/zh-TW/?aid=7278',
              name: 'Klook'
            }
          ],
          accomodationLinks: [
            {
              link: 'https://www.booking.com/index.zh-tw.html?aid=1285618',
              name: 'Booking.com'
            },
            {
              link: 'https://www.airbnb.com.tw/c/guoxuanp',
              name: 'Airbnb'
            }
          ],
          popularActivityLinks: [
            {
              link: 'https://reurl.cc/qYLo0',
              name: '嵐山嵯峨野小火車車票（關西機場領取）',
              frontDescription: '關西'
            },
            {
              link: 'https://reurl.cc/3M4oM',
              name: '關西機場直達京都HARUKA號特急票',
              frontDescription: '關西'
            },
            {
              link: 'https://reurl.cc/gY68b',
              name: '日本環球影城™ 1日電子門票',
              frontDescription: '關西'
            },
            {
              link: 'https://reurl.cc/VWME5',
              name: '環球影城 Express™快速通關券 4(可自選4項快速通關設施)',
              frontDescription: '關西'
            },
            {
              link: 'https://reurl.cc/koa5q',
              name: '京都一日遊""天橋立&伊根舟屋&美山茅屋之里""（大阪出發）',
              frontDescription: '關西'
            },
            {
              link: 'https://reurl.cc/WOOd9',
              name: '日本交通一卡通SUICA',
              frontDescription: '東京'
            },
            {
              link: 'https://reurl.cc/3MmQj',
              name: '成田機場至東京市區車票(比官網便宜)',
              frontDescription: '東京'
            },
            {
              link: 'https://reurl.cc/oYpEV',
              name: '東京地鐵1~3日券',
              frontDescription: '東京'
            },
            {
              link: 'https://reurl.cc/ekDNK',
              name: '吉卜力美術館一日團：（附保證入館門票）',
              frontDescription: '東京'
            },
            {
              link: 'https://bit.ly/2JCZIhZ',
              name: '淺草和服',
              frontDescription: '東京'
            },
            {
              link: 'https://reurl.cc/7Vqnk',
              name:
                '美麗海套票Enjoy Pass （含美麗海水族館門票及其他11處景點選4處）',
              frontDescription: '沖繩'
            },
            {
              link: 'https://reurl.cc/NNnAe',
              name: '瑪莉歐賽車體驗',
              frontDescription: '沖繩'
            },
            {
              link: 'https://reurl.cc/XQbQj',
              name: '恩納村藍洞潛水',
              frontDescription: '沖繩'
            }
          ],
          reservationMessage: `如果你想要預約餐廳，請先加入Tabiko VIP會員方案✨<br>
          加入後就能免費預約餐廳以及提供其他專屬服務，你也可以到個人頁面上方點擊“加入Tabiko VIP會員方案“了解更多！`
        }
      }
    };
  },

  methods: {},

  computed: {
    ...mapConciergeState({
      currentConcierge: state => state.currentConcierge
    }),

    getEnglishContent: function() {
      return this.content['en-US'];
    },

    getEnglishWelcomeMessage: function() {
      return `Hi there! I'm ${this.currentConcierge.screenName}, your travel concierge here at Tabiko.
      What can I help you with today?😊`;
    },

    getChineseTWContent: function() {
      return this.content['zh-TW'];
    },

    getChineseWelcomeMessage: function() {
      return `哈囉～我是你的旅遊小幫手${this.currentConcierge.screenName}！
      想要預約日本餐廳、詢問旅遊問題或是安排行程，我都可以幫忙與解答😊`;
    }
  }
};
